/**
 * Request options with OData Model
 */

/**
 * Request options with Request Init parameter
 */

/**
 * Defines options for a Load request
 */

/**
 * Defines options for a collection load request
 */

/**
 * Defines options for a Post request
 */

/**
 * Defines options for a patch request
 */

/**
 * Defines options for a Put request
 */

/**
 * Options for a delete request
 */

/**
 * Options for a content move request
 */

/**
 * Options for a content copy request
 */

/**
 * Options to call an odata action
 */

/**
 * Options for fetching content actions
 */

/**
 * Options for uploading content
 */

/**
 * Options for uploading a File into the repository
 */

/**
 * Options for uploading a text as a binary file into the repository
 */

/**
 * Options for uploading content from a drop event
 */

/**
 * Options for uploading files from a FileList object
 */
export let SharingLevel;

(function (SharingLevel) {
  SharingLevel["Open"] = "Open";
  SharingLevel["Edit"] = "Edit";
})(SharingLevel || (SharingLevel = {}));

export let SharingMode;
/**
 * Options for a content share request
 */

(function (SharingMode) {
  SharingMode["Private"] = "Private";
  SharingMode["Authenticated"] = "Authenticated";
  SharingMode["Public"] = "Public";
})(SharingMode || (SharingMode = {}));
//# sourceMappingURL=RequestOptions.js.map